import axios from 'axios'

export const leapsActionService = ({
  getLeapsActionList (token) {
    return axios.get('/api/leaps/actions', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createLeapsAction (token, formDataObj) {
    return axios.post('/api/leaps/actions', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateLeapsAction (token, formDataObj) {
    return axios.put('/api/leaps/actions', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteLeapsAction (token, actionLibraryId) {
    return axios.delete('/api/leaps/actions?ActionLibraryId=' + actionLibraryId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteActionToolkitFile (token, actionLibraryId) {
    return axios.delete('/api/leaps/actions/' + actionLibraryId + '/toolkit', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAttachedGoalForAction (token, actionLibraryId) {
    return axios.get('/api/leaps/availableactionsgoal?actionId=' + actionLibraryId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/leaps-action-service.js